import * as React from 'react';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import clsx from 'clsx';
export type RadioButtonOption = {
	id: string;
	value: string;
	label: string;
	breakLine?: boolean;
	disabled?: boolean;
};

type RadioSize = 'sm' | 'md';
interface Props {
	value: string;
	options: RadioButtonOption[];
	defaultValue?: string;
	disabled?: boolean;
	orientation?: 'horizontal' | 'vertical';
	size?: RadioSize;
	classNameContainer?: string;
	onChange: (value: string) => void;
	className?: string;
	labelPlacement?: 'left' | 'right';
}

export const RadioButtonV2: React.FC<Props> = ({
	orientation = 'horizontal',
	defaultValue,
	disabled,
	options,
	size = 'md',
	value,
	classNameContainer,
	className,
	labelPlacement = 'right',
	onChange,
}) => {
	const sizeClasses = {
		sm: 'h-4 w-4',
		md: 'h-6 w-6',
	};

	return (
		<RadioGroup
			value={value}
			defaultValue={defaultValue}
			onValueChange={onChange}
			orientation={orientation}
			className={clsx('', className, {
				'flex flex-col': orientation === 'vertical',
			})}
			disabled={disabled}
		>
			{options.map(({ id, value, label, breakLine, disabled }, index) => {
				const containerClasses = clsx(
					'flex items-center mb-2 last:mb-0',
					{
						'flex-row-reverse justify-between w-full':
							labelPlacement === 'left',
						'space-x-2': labelPlacement === 'right',
					},
					classNameContainer
				);

				const labelClasses = clsx('text-black text-base cursor-pointer', {
					'flex-1': labelPlacement === 'left',
				});

				const radioItem = (
					<RadioGroupItem
						disabled={disabled}
						value={value}
						id={id}
						size={size}
						className={clsx(
							'bg-gradient-to-b from-[#FFFFFF] to-[#F4F4F9] border-opacity-primary',
							sizeClasses[size]
						)}
					/>
				);

				const labelItem = (
					<label htmlFor={id} className={labelClasses}>
						{label}
					</label>
				);

				return (
					<React.Fragment key={index}>
						{breakLine && (
							<div className="h-[1px] w-full bg-gray-100 my-2"></div>
						)}
						<div className={containerClasses}>
							{radioItem}
							{labelItem}
						</div>
					</React.Fragment>
				);
			})}
		</RadioGroup>
	);
};
